export default "__VITE_ASSET__BPJUAR3S__"